import firebase from 'services/firebase';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const functions = getFunctions(firebase);

const hostname = window.location.hostname;
if (hostname === 'localhost' || hostname === '127.0.0.1') {
  connectFunctionsEmulator(functions, hostname, 5001);
}

export default functions;

